import { tv, type VariantProps } from 'tailwind-variants';

export const smartStartCardV4Variants = tv({
  // eslint-disable-next-line i18next/no-literal-string -- Tailwind class names
  base: ['flex', 'items-center', 'gap-4', 'p-4', 'rounded-2xl', 'border', 'transition-colors'],
  variants: {
    disabled: {
      true: 'bg-muted/40 cursor-not-allowed border-transparent',
      false: [
        'bg-card border-border-light cursor-pointer hover:bg-muted',
        'focus-visible:outline focus-visible:outline-2 focus-visible:outline-primary focus-visible:outline-offset-2',
      ].join(' '),
    },
  },
  defaultVariants: {
    disabled: false,
  },
});

export type SmartStartCardV4VariantProps = VariantProps<typeof smartStartCardV4Variants>;
